import PropTypes from 'prop-types';
import React, { createContext, useState, useEffect } from 'react';

import { toast } from 'react-toastify';

// Services
import { getAnonymProcessesService } from '../services/Process';

export const ContentProcessContext = createContext();

export const ContentProcessContextProvider = (props) => {
  // States
  const [processState, setProcessState] = useState();
  const [processDescriptor, setProcessDescriptor] = useState();
  const [processes, setProcesses] = useState();
  const [creationProcess, setCreationProcess] = useState();
  const [monitoringProcess, setMonitoringProcess] = useState();
  const [searchableProcess, setSearchableProcess] = useState();
  const [reassignProcess, setReassignProcess] = useState();
  const [anonymProcesses, setAnonymProcesses] = useState(new Map());

  const handleAnonymProcesses = async () => {
    try {
      const resp = await getAnonymProcessesService();
      if (resp) {
        resp.data.process.forEach((elem) => {
          setAnonymProcesses(
            (map) => new Map(map.set(elem.descriptor_p, { id: elem.id, url: elem.url_redirect, logo: elem.logo }))
          );
        });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  useEffect(() => {
    handleAnonymProcesses();
  }, []);
  // ------------------------------------------- //
  // ----------------- Return ------------------ //
  // ------------------------------------------- //

  return (
    <ContentProcessContext.Provider
      value={{
        processState,
        processDescriptor,
        processes,
        anonymProcesses,
        creationProcess,
        monitoringProcess,
        searchableProcess,
        reassignProcess,
        setCreationProcess,
        setMonitoringProcess,
        setSearchableProcess,
        setReassignProcess,
        setAnonymProcesses,
        setProcesses,
        setProcessState,
        setProcessDescriptor,
      }}
    >
      {props.children}
    </ContentProcessContext.Provider>
  );
};

ContentProcessContextProvider.propTypes = {
  children: PropTypes.node,
};
